import { Trans } from '@lingui/react/macro';
import { addBusinessDays } from 'date-fns/addBusinessDays';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import IconCalendar from '@/icons/Calendar.svg';
import { I18nWording, useDatabaseTranslation } from '@/services/i18n';
import { formatDate } from '@/utils/date';

export const DueAtType = ({
  translationType,
  days,
}: {
  translationType: I18nWording;
  days: number;
}) => {
  const isBefore10 = new Date().getUTCHours() < 10;
  const dueAt = addBusinessDays(new Date(), isBefore10 ? days - 1 : days);
  const formattedDate = formatDate(dueAt, { day: '2-digit', month: 'short', year: 'numeric' });
  const { _db } = useDatabaseTranslation();

  return (
    <Stack row gap="0.5rem" alignItems="center">
      <IconCalendar style={{ fontSize: '1.25rem' }} />
      <InlineText>
        {_db(translationType)}
        <Trans id="_general.colon">:</Trans>
      </InlineText>
      <InlineText weight="medium">{formattedDate}</InlineText>
    </Stack>
  );
};
